export const generatedScenarioDecisionDeltaLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-scenario-decision-delta-ledger",
  "operatingRule": "Decision delta records are the fail-closed acceptance layer for diligence work orders. A work order cannot change a customer-facing scenario answer until an after-run artifact records rank, lane, uncertainty, blocker, proof-gate, and customer-use deltas with hashes and reviewer approval.",
  "deltaRecordCount": 12,
  "blockedDeltaRecordCount": 12,
  "acceptedDeltaRecordCount": 0,
  "materialChangeDetectedCount": 0,
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "laneCounts": {
    "runtime-validation": 3,
    "process-physics": 3,
    "release-proof": 1,
    "resource-confidence": 4,
    "economics-sensitivity": 1
  },
  "priorityCounts": {
    "P0-critical-path": 3,
    "P1-business-grade": 9
  },
  "evidenceHashes": {
    "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
    "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
    "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
  },
  "deltaRecords": [
    {
      "id": "decision-delta-diligence-work-order-01-gap-runtime-orekit-propagation-v1",
      "workOrderId": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
      "workOrderHash": "sha256-baa82fd4ea74aad62b55dfc56fd78e1513cac8ba3a0e6cbc136c02b3d128e4d1",
      "linkedGapId": "gap-runtime-orekit-propagation-v1",
      "linkedExperimentId": "experiment-01-gap-runtime-orekit-propagation-v1",
      "lane": "runtime-validation",
      "priorityLane": "P0-critical-path",
      "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "mercury-orbit",
            "rank": 4,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 42.95,
            "decisionReadinessScore": 44.15,
            "uncertaintyBudgetPoints": 65.61,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-696d7bc5b812c609e983bf3c079ea9563eab372629e6c8847f831b0238d1f98a"
    },
    {
      "id": "decision-delta-diligence-work-order-02-gap-runtime-gmat-transfer-v1",
      "workOrderId": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
      "workOrderHash": "sha256-571ba2ce848959e9016799486d0505720f857685f02a601c2cc09e7f58a3e476",
      "linkedGapId": "gap-runtime-gmat-transfer-v1",
      "linkedExperimentId": "experiment-02-gap-runtime-gmat-transfer-v1",
      "lane": "runtime-validation",
      "priorityLane": "P0-critical-path",
      "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "mercury-orbit",
            "rank": 4,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 42.95,
            "decisionReadinessScore": 44.15,
            "uncertaintyBudgetPoints": 65.61,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-1d9e48de12c1383de449b7b80a4a1172bb99fa0ed70cb8a8a7f690c2a5af0ee1"
    },
    {
      "id": "decision-delta-diligence-work-order-03-gap-runtime-tudat-transfer-v1",
      "workOrderId": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
      "workOrderHash": "sha256-74ae877ca9b3c8c030f093f9b35cfd3239f6069c924c1f0da02bf9b6c1d98710",
      "linkedGapId": "gap-runtime-tudat-transfer-v1",
      "linkedExperimentId": "experiment-03-gap-runtime-tudat-transfer-v1",
      "lane": "runtime-validation",
      "priorityLane": "P0-critical-path",
      "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "mercury-orbit",
            "rank": 4,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 42.95,
            "decisionReadinessScore": 44.15,
            "uncertaintyBudgetPoints": 65.61,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-dd7181fa4835fbf55f8cc5153d6058a2e2ab8244eab1ad37cb46cd9c5221f562"
    },
    {
      "id": "decision-delta-diligence-work-order-04-gap-materials-process-oxygen-isru",
      "workOrderId": "diligence-work-order-04-gap-materials-process-oxygen-isru",
      "workOrderHash": "sha256-bdf99d78b39494df13a8409aa9336affd690e24fd93ec58fdc5b56e258143622",
      "linkedGapId": "gap-materials-process-oxygen-isru",
      "linkedExperimentId": "experiment-04-gap-materials-process-oxygen-isru",
      "lane": "process-physics",
      "priorityLane": "P1-business-grade",
      "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "moon-first",
            "rank": 1,
            "decisionLane": "lane-2-conditional-diligence",
            "deterministicUtility": 67.12,
            "decisionReadinessScore": 62.91,
            "uncertaintyBudgetPoints": 29.81,
            "uncertaintyClass": "managed-beta-uncertainty",
            "customerUseState": "paid-beta-internal-diligence",
            "blockerCount": 13,
            "dossierHash": "sha256-9875bb78ef63e46d736345da0f793778851eafb82f37ef91ca9edde3f3db3573"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "moon-first",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-df7112d8c2bc06bcc2841ce59520b9ee885d5eeac25df494a604b49a79e25b83"
    },
    {
      "id": "decision-delta-diligence-work-order-05-gap-readiness-science-math-credibility",
      "workOrderId": "diligence-work-order-05-gap-readiness-science-math-credibility",
      "workOrderHash": "sha256-6e0809c818212af1f7017609be842f01e31c381d04b54fc7f66db8f75606e2d6",
      "linkedGapId": "gap-readiness-science-math-credibility",
      "linkedExperimentId": "experiment-05-gap-readiness-science-math-credibility",
      "lane": "release-proof",
      "priorityLane": "P1-business-grade",
      "buyerQuestion": "Required to raise the beta from testable to release-grade.",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "mercury-orbit",
            "rank": 4,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 42.95,
            "decisionReadinessScore": 44.15,
            "uncertaintyBudgetPoints": 65.61,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-60ac72f959528d9472829942ff72d11f66c1f5ef35f01e760a401819e06eafa9"
    },
    {
      "id": "decision-delta-diligence-work-order-06-gap-candidate-source-2026-em",
      "workOrderId": "diligence-work-order-06-gap-candidate-source-2026-em",
      "workOrderHash": "sha256-ca289d3590ea16900ade0899719bc6f367b45d272c91c2e61f4110ea941a5e16",
      "linkedGapId": "gap-candidate-source-2026-em",
      "linkedExperimentId": "experiment-06-gap-candidate-source-2026-em",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "asteroid-first",
            "rank": 3,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 51.37,
            "decisionReadinessScore": 41.63,
            "uncertaintyBudgetPoints": 62.38,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-asteroid-feedstock-screen-v1",
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-e80560acfdc667dad2bc92f845f13cd8b86102818332de3fb04474fcbcda5b5a"
    },
    {
      "id": "decision-delta-diligence-work-order-07-gap-candidate-source-2026-jm2",
      "workOrderId": "diligence-work-order-07-gap-candidate-source-2026-jm2",
      "workOrderHash": "sha256-708045573dcd7b1b11a8d0644a1306575d7ae399481f6842235f66802c679332",
      "linkedGapId": "gap-candidate-source-2026-jm2",
      "linkedExperimentId": "experiment-07-gap-candidate-source-2026-jm2",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "asteroid-first",
            "rank": 3,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 51.37,
            "decisionReadinessScore": 41.63,
            "uncertaintyBudgetPoints": 62.38,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-asteroid-feedstock-screen-v1",
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-773d432f747db4658c55e62bf6391a5a0810a3656b643105ca7748704fe78898"
    },
    {
      "id": "decision-delta-diligence-work-order-08-gap-candidate-source-2026-dn5",
      "workOrderId": "diligence-work-order-08-gap-candidate-source-2026-dn5",
      "workOrderHash": "sha256-7aba6c179ff641753e4dcf699a4c2e196f07d7a2ebadbb931690035802d2f143",
      "linkedGapId": "gap-candidate-source-2026-dn5",
      "linkedExperimentId": "experiment-08-gap-candidate-source-2026-dn5",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "asteroid-first",
            "rank": 3,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 51.37,
            "decisionReadinessScore": 41.63,
            "uncertaintyBudgetPoints": 62.38,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-asteroid-feedstock-screen-v1",
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-21f28e19a52de7ba3e8f2e9a5044ace620f6e821196ba50698501bdedd753f40"
    },
    {
      "id": "decision-delta-diligence-work-order-09-gap-materials-process-spf-db",
      "workOrderId": "diligence-work-order-09-gap-materials-process-spf-db",
      "workOrderHash": "sha256-0f76d2cba16f3e50d606a4ca6ba58e7b0b55ff94806314a9f1fc37a2016034b4",
      "linkedGapId": "gap-materials-process-spf-db",
      "linkedExperimentId": "experiment-09-gap-materials-process-spf-db",
      "lane": "process-physics",
      "priorityLane": "P1-business-grade",
      "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "mercury-orbit",
            "rank": 4,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 42.95,
            "decisionReadinessScore": 44.15,
            "uncertaintyBudgetPoints": 65.61,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-95129d4fc91c08b0c00ca68a2ff935fb273fae66f1edc1de744fff2ca6f59f21"
    },
    {
      "id": "decision-delta-diligence-work-order-10-gap-materials-process-vacuum-sheet",
      "workOrderId": "diligence-work-order-10-gap-materials-process-vacuum-sheet",
      "workOrderHash": "sha256-ef9e747934d358294e2459299e33ef07454fd7880972a251177e083cda4c7169",
      "linkedGapId": "gap-materials-process-vacuum-sheet",
      "linkedExperimentId": "experiment-10-gap-materials-process-vacuum-sheet",
      "lane": "process-physics",
      "priorityLane": "P1-business-grade",
      "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "mercury-orbit",
            "rank": 4,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 42.95,
            "decisionReadinessScore": 44.15,
            "uncertaintyBudgetPoints": 65.61,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-036615a4391727c3d648d7fcfd87e2ff43f1656b69612c3d470607fc56107110"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-2dd2f4bde9c960b939f68769edcb13c553ce19b66b07e1cd0d7d4926812bd121"
    },
    {
      "id": "decision-delta-diligence-work-order-11-gap-resource-taxonomy-spectra-record",
      "workOrderId": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
      "workOrderHash": "sha256-ce13be2de8e222b90b3f72ab64e82567f72bc328ddf50d0cdf34b08ecf7cd089",
      "linkedGapId": "gap-resource-taxonomy-spectra-record",
      "linkedExperimentId": "experiment-11-gap-resource-taxonomy-spectra-record",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "asteroid-first",
            "rank": 3,
            "decisionLane": "lane-4-research-backlog",
            "deterministicUtility": 51.37,
            "decisionReadinessScore": 41.63,
            "uncertaintyBudgetPoints": 62.38,
            "uncertaintyClass": "high-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-asteroid-feedstock-screen-v1",
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-a7d57999cd5183edec36a6a8900ac7bd7618bbe6be4ee0c9de0241042489605e"
    },
    {
      "id": "decision-delta-diligence-work-order-12-gap-economics-launch-list-price-source",
      "workOrderId": "diligence-work-order-12-gap-economics-launch-list-price-source",
      "workOrderHash": "sha256-98529615ecd1f236b1f6ea583e4019269b6871fe39b3b94d8d0dc2b797ce60e6",
      "linkedGapId": "gap-economics-launch-list-price-source",
      "linkedExperimentId": "experiment-12-gap-economics-launch-list-price-source",
      "lane": "economics-sensitivity",
      "priorityLane": "P1-business-grade",
      "buyerQuestion": "Do dated, normalized cost and market inputs change the scenario ranking or capital gap?",
      "acceptanceState": "blocked-pending-after-run-artifact",
      "commercialUseAllowed": false,
      "customerUseAllowed": false,
      "baseline": {
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarios": [
          {
            "scenarioId": "moon-first",
            "rank": 1,
            "decisionLane": "lane-2-conditional-diligence",
            "deterministicUtility": 67.12,
            "decisionReadinessScore": 62.91,
            "uncertaintyBudgetPoints": 29.81,
            "uncertaintyClass": "managed-beta-uncertainty",
            "customerUseState": "paid-beta-internal-diligence",
            "blockerCount": 13,
            "dossierHash": "sha256-9875bb78ef63e46d736345da0f793778851eafb82f37ef91ca9edde3f3db3573"
          },
          {
            "scenarioId": "hybrid",
            "rank": 2,
            "decisionLane": "lane-3-watchlist",
            "deterministicUtility": 65.69,
            "decisionReadinessScore": 59.78,
            "uncertaintyBudgetPoints": 43.88,
            "uncertaintyClass": "medium-uncertainty",
            "customerUseState": "research-backlog-only",
            "blockerCount": 13,
            "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
          }
        ]
      },
      "afterRunArtifactRequired": {
        "required": true,
        "acceptedArtifactType": "scenario-decision-delta-after-run",
        "requiredFields": [
          "rankPositionDelta",
          "decisionLaneDelta",
          "uncertaintyBudgetDelta",
          "blockerCountDelta",
          "proofGateStateDelta",
          "customerUseStateDelta"
        ],
        "requiredEvidence": [
          "after-run scenario decision ledger hash",
          "after-run customer decision dossier ledger hash",
          "after-run scenario uncertainty budget ledger hash",
          "model-run comparison hash",
          "reviewer approval for changed customer-facing wording"
        ],
        "intakeCommand": "npm run science:report",
        "validationCommand": "node --test tests/scenario-decision-delta-ledger.test.mjs"
      },
      "afterRun": null,
      "deltaSummary": {
        "materialChangeDetected": false,
        "acceptedChange": false,
        "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
        "materialChangeRule": "A work order materially changes the business answer only when at least one affected scenario changes rank, decision lane, uncertainty band, blocker count, or customer-use state."
      },
      "affectedPackageIds": [
        "package-investor-feasibility-brief-v1",
        "package-science-validation-backlog-v1"
      ],
      "affectedScenarioIds": [
        "moon-first",
        "hybrid"
      ],
      "evidenceHashes": {
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
      },
      "deltaHash": "sha256-c3233721471f01f0338f5f8ec60131bf349a311c66d08f2518ab0eecf660efc4"
    }
  ],
  "ledgerHash": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de"
}
;
